import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[focus]'
})
export class FocusDirective {

    @Input() public focus: boolean;

    public constructor(private el: ElementRef) {

    }

    ngOnChanges() {
        if(this.focus) {   
          this.el.nativeElement.focus();
        }
      }




}